import React from "react";
import { Outlet } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";

export default function AdminLayout() {
  return (
    <>
      <AdminNavbar />

      <div className="admin-content">
        <Outlet />
      </div>
    </>
  );
}